import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CategoryProviderProvider } from './Contexts/CategoryContext';
import { UserContextProvider } from './Contexts/UserContext';
import { LocationProvider } from './Contexts/LocationContext';
import Routings from './Routes/Routes';
import ReactGA from "react-ga4";
import { AddProvider } from './Contexts/AddContext';


function App() {

  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
  ReactGA.initialize(trackingId);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Traffic hit" });

  return (

    <CategoryProviderProvider>
      <UserContextProvider>
        <LocationProvider>
          <AddProvider >
        <div>
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnHover={false} theme="colored" />
          <Routings />
        </div>
        </AddProvider>
        </LocationProvider>
      </UserContextProvider>
    </CategoryProviderProvider>
  );
}

export default App;
